import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { authReady } = useAuth();
  const location = useLocation();

  if (!authReady) return null; // or a spinner

  // Check any stored token — prefer access token, fall back to id token
  const token =
    localStorage.getItem('rv_access_token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('rv_id_token') ||
    localStorage.getItem('id_token');

  // A valid token means Cognito confirmed this user — don't require the
  // backend to be reachable to stay authenticated.
  const hasValidToken = (() => {
    if (!token) return false;
    try {
      const [, payload] = token.split('.');
      const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
      return claims.exp > Math.floor(Date.now() / 1000);
    } catch {
      return false;
    }
  })();

  // Token is the only source of truth for Cognito — a stale `user` object
  // in React state must NOT keep the gates open once the token has expired.
  const isAuthed = hasValidToken;

  if (!isAuthed) {
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }
  return children;
}